import { reviews } from "@/mocks/site";
import SectionHeading from "@/components/base/SectionHeading";

export default function Reviews() {
  return (
    <section className="w-full bg-background-50 py-10 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="读者口碑"
          title="读者怎么说"
          center
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
          {reviews.map((r) => (
            <figure
              key={r.name}
              className="flex flex-col justify-between rounded-lg border border-background-200/70 bg-background-100 p-6"
            >
              <div>
                <div className="flex gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-4 text-sm leading-7 text-foreground-800">
                  “{r.text}”
                </blockquote>
              </div>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                  {r.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-semibold text-foreground-950">{r.name}</span>
                  <span className="block text-xs text-foreground-500">{r.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}